import { faPause, faPlay } from "@fortawesome/free-solid-svg-icons";
import { useStreamingState } from "../../contexts/StreamingState";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Button } from "../Button";
import { useVideoPlayerRefs } from "../../contexts/VideoPlayerRefs";
import { StreamingState } from "../../types/streamingState";

export const PlayPauseButton = () => {
  const { video } = useVideoPlayerRefs();
  const { streamingState } = useStreamingState();

  const icon = streamingState === StreamingState.playing ? faPause : faPlay;

  const onClick =
    streamingState === StreamingState.playing
      ? () => video.current?.pause()
      : async () => video.current?.play();

  const iconStyle = {
    height: 28,
  };

  return (
    <Button onClick={onClick}>
      <FontAwesomeIcon icon={icon} style={iconStyle} />
    </Button>
  );
};
